'use client';

import Link from 'next/link';
import { trackCTAClick } from '@/lib/analytics';
import useScrollReveal from '@/hooks/useScrollReveal';

export default function CTASection() {
  const { ref: sectionRef, isVisible: sectionVisible } = useScrollReveal<HTMLElement>();

  return (
    <section ref={sectionRef} className="py-32 md:py-40 bg-brand-plum">
      <div className={`max-w-5xl mx-auto px-6 sm:px-8 lg:px-12 text-center transition-all duration-1000 ${sectionVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
        <h2 className="font-headline text-6xl md:text-7xl lg:text-8xl text-white mb-10 font-bold leading-tight">
          Ready to Create Your Success Story?
        </h2>
        <p className="font-body text-2xl md:text-3xl text-white/90 mb-16 leading-relaxed">
          Let's build the infrastructure your business needs to thrive.
        </p>
        <Link
          href="/contact"
          onClick={() => trackCTAClick('Start the Conversation', 'CTA Section - Portfolio')}
          className="group inline-flex items-center gap-4 px-12 py-6 bg-brand-teal text-white font-body font-bold text-xl rounded-xl hover:bg-brand-green hover:shadow-hover transition-all duration-300 shadow-button transform hover:scale-105 active:scale-95 active:shadow-md"
        >
          <span className="flex items-center gap-4">
            Start the Conversation
            <span className="text-3xl">→</span>
          </span>
        </Link>
      </div>
    </section>
  );
}